import { useContext } from 'react';
import { FeathersContext } from '../FeathersContext';
import { Application } from '@feathersjs/feathers';
import { TFeathersContext } from '../types';

export function useFeathersClient(): Application {
  const feathersContext = useContext(FeathersContext) as TFeathersContext;
  return feathersContext.client;
}
